import { JSONValue, WidenPrimitives } from '@growthbook/growthbook';
import { IExtensionInfo, IFlagsConfig } from '@/models';
import { GROWTH_BOOK } from '@/constants/features/feature-flag';
import { canUseBucketsOptInExperience } from '@/utils/helpers/opt-in';
import {
  CONSENT_VARIANTS,
  ConsentVariantId,
  DEFAULT_CONSENT_VARIANT_ID,
  IConsentVariant,
  isConsentVariantId,
} from '../config/variants';

export interface ResolvedConsentVariant {
  // null for legacy users — they keep the pre-buckets flow entirely.
  variantId: ConsentVariantId | null;
  variant: IConsentVariant | null;
}

type GetFeatureValue = <T extends JSONValue>(
  key: string,
  fallbackValue: T
) => WidenPrimitives<T>;

// Pure variant resolution so callers outside React (e.g. post-login) can resolve
// the same variant the hook renders, without a component subscription.
export const resolveConsentVariant = (
  flags: IFlagsConfig,
  extensionInfo: IExtensionInfo | null,
  getFeatureValue: GetFeatureValue
): ResolvedConsentVariant => {
  if (!canUseBucketsOptInExperience(flags, extensionInfo)) {
    return { variantId: null, variant: null };
  }

  const rawValue = getFeatureValue<string>(
    GROWTH_BOOK.FEATURES.OPTIN_CONSENT_VARIANT,
    DEFAULT_CONSENT_VARIANT_ID
  );
  const variantId = isConsentVariantId(rawValue)
    ? rawValue
    : DEFAULT_CONSENT_VARIANT_ID;
  return { variantId, variant: CONSENT_VARIANTS[variantId] };
};
